import { render, staticRenderFns } from "./myOrderRouter.vue?vue&type=template&id=b9fa1408&scoped=true&"
import script from "./myOrderRouter.vue?vue&type=script&lang=js&"
export * from "./myOrderRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fa1408",
  null
  
)

export default component.exports